import { Formik } from "formik";
import React, { useState, useEffect } from "react";
import { Button, ButtonGroup, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import ReactSelect from 'react-select';
import reseticon from "assets/icon/reset.svg";
import searchicon from "assets/icon/search.svg";
import DatePicker from 'react-datepicker';
import ReactInputMask from 'react-input-mask';
import useAxios from "hooks/useAxios";
import { dateFormate } from "utils/columns";
import moment from "moment";
import Calendar from 'assets/icon/calendar-icon.svg';
import useContextService from "hooks/useContextService";
import { Option, LimitedChipsContainer } from 'components/Options';




let hasDatePopupOpen = false;
let coveredEntitiesData = [];
let accumulationData = [];
const acunttypeptions = [
    { id: 'All', label: 'All' },
    { id: '340B', label: '340B' },
    { id: 'GPO', label: 'GPO' },
    { id: 'WAC', label: 'WAC' },
    { id: 'Pending', label: 'Pending' },

];
let coveredEntityError = 'Covered Entity Name is a required field';
let accumulatorError = 'Accumulator is a required field';
const SearchContainer = (props) => {

    const [isSubmited, serIsSubmitted] = useState(false);
    const [isStartDate, setIsStartDate] = useState(null);
    const [isEndDate, setIsEndDate] = useState(null);
    const [hasACCSelected, setACCSelected] = useState(true);
    const [hasCESelected, setCESelected] = useState(true);
    const [loading, setLoading] = useState(false);
    const [acccountype, setAccountype] = useState('All');
    const [encountr, setEncounter] = useState('');
    const [err, setError] = useState('');
    const [selectedCEOption, setCEOptionSelected] = useState({
        optionCESelected: "-1",
    });
    const [selectedACCOption, setOptionACCSelected] = useState({
        optionACCSelected: "-1",
    });
    const {
        orgId,
        onSearch,
        reset
    } = props;
    const {
        states: { rxManager },
        setStates,
        resetStates,
    } = useContextService();
    const { search, coveredEntities, searchTerms, accumulations, } = rxManager;



    let {
        startDate,
        encounter,
        endDate,
        accumulationIDs,
    } = searchTerms;
    const API = useAxios();

    useEffect(() => {
        serIsSubmitted(false);
        setCESelected(true);
        setACCSelected(true);
        coveredEntitiesData = [];
        accumulationData = [];
        rxManager.searchTerms.coveredEntityIDs = [];
        rxManager.searchTerms.accumulationIDs = {};
        rxManager.searchTerms.startDate = '';
        rxManager.searchTerms.enDate = '';
        rxManager.accumulations = [];
        setIsStartDate(null);
        setIsEndDate(null);
        updateStates(rxManager);
        setCEOptionSelected({ optionCESelected: '-1' });
        setOptionACCSelected({ optionACCSelected: '-1' });
        fetchCoveredEntities();
    }, [orgId]);
    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };
    const updateStates = (rxManager) => {
        setStates("rxManager", rxManager);
    };
    const handleAccounttype = (e) => {
        setAccountype(e.target.value);
        rxManager.searchTerms.acunttype = e.target.value;
    }

    const fetchCoveredEntities = async () => {
        debugger;
        //let { organizationID } = orgId;
        if (typeof orgId !== "undefined" && orgId !== null) {
            coveredEntitiesData = [];
            rxManager.searchTerms.coveredEntityIDs = [];
            updateStates(rxManager);

            let selectedOrgId = orgId.organizationID;

            setLoading(false);
            try {
                const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
                    hasDefaultURL: true,
                });
                setLoading(false);
                if (data) {
                    for (var x in data) {
                        coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
                    }
                    console.log(data, "Data");
                    rxManager.coveredEntities = data;

                    if (coveredEntitiesData.length == 1) {
                        var ceData = [];
                        ceData.push(coveredEntitiesData[0])
                        rxManager.searchTerms.coveredEntityIDs = ceData;
                        window.selectedCoveredEntittyId = ceData;
                    }
                    if (window.selectedCoveredEntittyId.length > 0) {
                        rxManager.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
                    }

                    updateStates(rxManager);
                    if (rxManager.searchTerms.coveredEntityIDs) {

                        var ceSelected = [];
                        ceSelected.optionCESelected = [];
                        for (var x in rxManager.searchTerms
                            .coveredEntityIDs) {
                            ceSelected.optionCESelected.push(
                                rxManager.searchTerms.coveredEntityIDs[x]
                            );
                        }
                        setCEOptionSelected(ceSelected);
                        let ceIds = rxManager.searchTerms.coveredEntityIDs.map(item => item["value"]);
                        fetchAccumulatorName(ceIds);
                    }

                }
            }
            catch (err) {
                setLoading(false);
            }
        }

    };
    const fetchAccumulatorName = async (coveredEntityIDs) => {

        if (coveredEntityIDs !== undefined && coveredEntityIDs.length > 0) {
            try {
                accumulationData = [];
                const payload = {};
                payload.CEIDS = coveredEntityIDs;
                // payload.AccumulatorEntityList = coveredEntityIDs;
                let AccumulatorEntityList = [payload.AccumulatorEntityList]
                const result = await API.post(`SBConfig/coveredentity/acclistall`, payload,
                    {
                        hasDefaultURL: true,
                    }
                );
                if (result) {
                    let accumulator = []
                    accumulator = result.data;
                    for (var x in accumulator) {
                        accumulationData.push({ "value": accumulator[x].accumulatorID, "label": accumulator[x].ceName });
                    }

                    if (accumulationData.length == 1) {
                        var AccData = [];
                        AccData.push(accumulationData[0])
                        rxManager.searchTerms.accumulationIDs = AccData;
                        handleAccumulatorname([accumulationData[0]]);

                    }
                    //   else if (window.selectedAccumulatorId.length > 0) {
                    //     rxManager.searchTerms.accumulationIDs =
                    //       window.selectedAccumulatorId;
                    //       handleAccumulatorname(window.selectedAccumulatorId[0]);
                    //   }
                    rxManager.accumulations = result.data;
                    updateStates(rxManager);
                    // if (accumulationIDs.length > 0) {
                    //     var accumulatorSelected = {};
                    //     accumulatorSelected.optionACCSelected = [];
                    //     for (var x in accumulationIDs) {
                    //         accumulatorSelected.optionACCSelected.push(accumulationIDs[x]);
                    //     }
                    //     setOptionACCSelected({ accumulatorSelected});
                    // }
                }
            } catch (error) {
                console.log(error.message);
            }
        }
    };
    const handleEndDate = (endDate) => {

        let enDate = dateFormate(endDate);
        setIsEndDate(enDate);
        rxManager.searchTerms.endDate = moment(new Date(endDate)).format(
            'MM/DD/YYYY'
        );
    };
    const handleEndDateRaw = (e) => {

        // var valdt = new Date(endDate)
        var val = e.target.value;
        var dt = moment(val, "MM/DD/YYYY", true);
        var isValid = dt.isValid();
        if (isValid == false && rxManager.searchTerms.endDate !== null && val == '__/__/____') {
            rxManager.searchTerms.endDate = null;
            setIsEndDate(null)
            updateStates(rxManager);
        }

        if (isValid) {
            const newDate = new Date(e.target.value);
            handleEndDate(newDate);
        }
    }
    const handleStartDate = (startDate) => {

        setError('');
        let stDate = dateFormate(startDate);
        setIsStartDate(stDate);
        rxManager.searchTerms.startDate = moment(new Date(startDate)).format(
            'MM/DD/YYYY'
        );
    };

    const handleStartDateRaw = (e) => {

        var val = e.target.value;
        var dt = moment(val, "MM/DD/YYYY", true);
        var isValid = dt.isValid();
        if (isValid == false && rxManager.searchTerms.startDate !== null) {
            rxManager.searchTerms.startDate = null;
            setIsStartDate(null);
            updateStates(rxManager);

        }

        if (isValid) {
            const newDate = new Date(e.target.value);
            handleStartDate(newDate);
        }
    }
    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };
    const handleCoverdEntityChange = (selected, setFieldValue, entity) => {
        // let selected = [selectedces == null ? []: selectedces]

        if (selected) {
            window.selectedCoveredEntittyId = selected;
            window.selectedAccumulatorId = [];
            accumulationData = [];
            // setSelectedNdc('');
            rxManager.searchTerms.accumulationIDs = {};
            setCESelected(true);
            setCEOptionSelected({
                optionCESelected: selected.value
            });
            let val = selected.value;
            rxManager.coveredEntities = selected;
            // setFieldValue('coveredEntityIDs', selected);
            rxManager.searchTerms.coveredEntityIDs = selected;
            if (Array.isArray(rxManager.searchTerms.coveredEntityIDs)) {
                accumulationIDs = {};
                rxManager.searchTerms.accumulationIDs = {};
            }
            let ceIds = rxManager.searchTerms.coveredEntityIDs.map(item => item["value"]);
            //rxManager.searchTerms.coveredEntityIDs = ceIds;
            updateStates(rxManager);
            fetchAccumulatorName(ceIds);
            setOptionACCSelected({ optionACCSelected: '-1' });
        }
        else {
            // setFieldValue('coveredEntityIDs', {});
            accumulationData = [];
            rxManager.coveredEntities = [];
            rxManager.searchTerms.coveredEntityIDs = {};
            rxManager.searchTerms.accumulationIDs = {};
            setCESelected(false);
            setACCSelected(false);
        }
        updateStates(rxManager);
    };
    const handleAccumulatorname = (selected, setFieldValue, ac) => {
debugger;
        //let selected = [selectedacs == null ? [] : selectedacs]
        //let selected = Array.isArray(selectedacs) ? selectedacs : [selectedacs];
        window.selectedAccumulatorId = selected;
        if (selected) {
            setACCSelected(true);
            setOptionACCSelected({
                optionACCSelected: selected
            })
            //   let val = selected.value;
            //   setFieldValue('accumulatorID', val);
            //   setFieldValue('accumulationIDs', selected);
            rxManager.searchTerms.accumulationIDs = selected;
        }
        else {
            setACCSelected(true);
            //   setFieldValue('accumulationIDs', {});
            accumulationData = [];
            rxManager.coveredEntities = [];
            rxManager.searchTerms.accumulationIDs = {};
            rxManager.searchTerms.coveredEntityIDs = {};
            setCESelected(false);
        }
        updateStates(rxManager);
    };
    const handelCancel = async() => {
        setCESelected(true);
        setACCSelected(true);
        // setError("");
        accumulationData = [];
        window.selectedCoveredEntittyId = "";
        window.selectedAccumulatorId = "";
        setCEOptionSelected({ optionCESelected: "-1" });
        setOptionACCSelected({ optionACCSelected: "-1" });
        rxManager.searchTerms.coveredEntityIDs = {};
        rxManager.searchTerms.accumulationIDs = {};
        rxManager.searchTerms.startDate = '';
        searchTerms.dateRange = {};
        rxManager.dateRange = {};
        rxManager.dateRangeID = null;
        rxManager.searchTerms.acunttype = 'All';
  
        setAccountype('All')
        setEncounter('');
        updateStates(rxManager);
        resetStates("rxManager");
        await reset()
    }
    const handleencounter = (e) => {
        debugger;
        const { value } = e.target;
        rxManager.searchTerms.encounter = value;
        setEncounter(value);
    }
    const validations = (ceIDs, acIDs, setSubmitting) => {
        if (ceIDs.length == 0) {
            setCESelected(false);
            if (acIDs.length == 0) {
                setACCSelected(false);
            }
            return setSubmitting(false);
        }
        if (ceIDs.length > 0 && acIDs.length == 0) {
            setACCSelected(false);
            return setSubmitting(false);
        }
    }
    const handleSubmit = async (val, actions) => {
        debugger;
        let values = {};
        serIsSubmitted(true);
        const { setSubmitting } = actions;
        let acIDs = [];
        let ceIDs = [];

        for (var x in searchTerms.accumulationIDs) {
            var rw = searchTerms.accumulationIDs[x];
            acIDs.push(rw.value);
        }
        for (var x in searchTerms.coveredEntityIDs) {
            var rw = searchTerms.coveredEntityIDs[x];
            ceIDs.push(rw.value);

        }
        if (validations(ceIDs, acIDs, setSubmitting));

        if (ceIDs > [0]) values.coveredEntityIDs = ceIDs;
        if (acIDs > [0]) values.accumulationIDs = acIDs;
        if (startDate) values.startDate = startDate;
        if ((startDate == null || startDate == "")) {
            return setError('Start date is required')
        }
        if ((startDate == null || startDate == "")) {
            return setError('End date is required')
        }

        values.acccountype = acccountype;
        values.encounter = rxManager.searchTerms.encounter;
        if (endDate) values.endDate = endDate;

        rxManager.search.currentPage = 1;
        updateStates(rxManager);
        await onSearch(values);
        setSubmitting(false);
    };
    return (
        <Formik
            initialValues={searchTerms}
            onSubmit={handleSubmit}
            // validationSchema={validationSchema}
            enableReinitialize={true}
            children={(props) => {
                const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                return (
                    <div >
                        <h6 className='f-16 text-primary font-weight-700'>Search Rx Manager</h6>
                        <div >
                            <Row sm={5} className='d-flex' style={{}}>
                                <Col md={3} lg={3} sm={6} xs={6}  >
                                    {' '}
                                    <FormGroup className='ce-reports'>
                                        <Label for='coveredentity'>Covered Entity</Label>
                                        <ReactSelect
                                            name='coveredentity'
                                            id='coveredentity'
                                            options={coveredEntitiesData}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            optionSelected={true}
                                            isClearable={true}
                                            components={{
                                                Option, ValueContainer: LimitedChipsContainer,
                                            }}
                                            isSearchable="true"
                                            onChange={(value, cp) =>
                                                handleCoverdEntityChange(value, setFieldValue, cp)}
                                            value={selectedCEOption.optionCESelected}
                                            className='claim_info required'
                                            maxMenuHeight={220}
                                            styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 99,
                                                }),
                                            }}
                                        />
                                        {!hasCESelected ? (
                                            <div className="text-danger f-12 position-absolute">
                                                {coveredEntityError}
                                            </div>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                                <Col md={3} lg={3} sm={6} xs={6}   >
                                    {' '}
                                    <FormGroup className='ce-reports'  >
                                        <Label for='accumulator'>Accumulator</Label>
                                        <ReactSelect
                                            name='accumulatorID'
                                            id='accumulationIDs'
                                            options={accumulationData}
                                           // isDisabled={accumulationData.length == 1}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            optionSelected={true}
                                            isClearable={true}
                                            components={{
                                                Option, ValueContainer: LimitedChipsContainer
                                            }}
                                            value={
                                                selectedACCOption.optionACCSelected
                                            }
                                            isSearchable="true"
                                            onChange={(value, ac) =>
                                                handleAccumulatorname(
                                                    value,
                                                    setFieldValue, ac
                                                )
                                            }

                                            className='claim_info required'
                                            
                                            maxMenuHeight={220}
                                            styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 99,
                                                }),
                                            }}
                                        />
                                        {(!hasACCSelected && isSubmited) ||
                                            (hasCESelected &&
                                                isSubmited &&
                                                selectedACCOption.optionACCSelected == "-1") ? (
                                            <div className="text-danger f-12 position-absolute">
                                                {accumulatorError}
                                            </div>
                                        ) : null}
                                    </FormGroup>
                                </Col>

                                <Col md={3}>
                                    <FormGroup>
                                        <Label >Claim Type</Label>
                                        <Input
                                            //defaultValue={'All'}
                                            //className='required'
                                            id="accountype"
                                            name="accountype"
                                            type='select'
                                            value={acccountype}
                                            onChange={handleAccounttype}
                                        >
                                            {acunttypeptions.map((status) => {
                                                const { id, label } = status;
                                                return (
                                                    <option key={id} value={label}>
                                                        {label}
                                                    </option>
                                                );
                                            })}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label >Encounter/MRN</Label>
                                        <Input type="text"
                                            name="encounter"
                                            onChange={handleencounter}
                                            placeholder="Enter MRN Number"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={3} className='required-date'>
                                    <FormGroup >
                                        <Label>Start Date</Label>
                                        <InputGroup onMouseLeave={handleMouseLeave}>
                                            <DatePicker
                                                id='isStartDate'
                                                name='isStartDate'
                                                selected={startDate}
                                                onChange={(e) => { handleStartDate(e) }}
                                                onChangeRaw={handleStartDateRaw}
                                                dateFormat="MM/dd/yyyy"
                                                placeholderText='Select a date'
                                                autoComplete='off'
                                                customInput={
                                                    <ReactInputMask mask="99/99/9999"
                                                        value={isStartDate}
                                                    // maskChar=''
                                                    />
                                                }
                                            />
                                            <InputGroupText
                                                onClick={() => handleDateClick('isStartDate')}
                                            >
                                                <img src={Calendar} alt='' />
                                            </InputGroupText>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={3} className='required-date'>
                                    <FormGroup >
                                        <Label>End Date</Label>
                                        <InputGroup onMouseLeave={handleMouseLeave}>
                                            <DatePicker
                                                id='endDate'
                                                name='endDate'
                                                selected={endDate}
                                                onChange={(e) => { handleEndDate(e) }}
                                                onChangeRaw={handleEndDateRaw}
                                                dateFormat="MM/dd/yyyy"
                                                placeholderText='Select a date'
                                                autoComplete='off'
                                                customInput={
                                                    <ReactInputMask mask="99/99/9999"
                                                        value={endDate}
                                                    // maskChar=''
                                                    />
                                                }
                                            />
                                            <InputGroupText
                                                onClick={() => handleDateClick('endDate')}
                                            >
                                                <img src={Calendar} alt='' />
                                            </InputGroupText>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Col md="auto" >
                                    <Label>{""}</Label>
                                    <Button

                                        color="primary"
                                        className="search"
                                        onClick={handleSubmit}

                                    // disabled={!coveredEntityid}
                                    // hidden={!hasPermission("ADD")}
                                    >
                                        <span className="right_5">
                                            <img src={searchicon} alt="" />
                                        </span>{" "}
                                        Search
                                    </Button>
                                    <Button
                                        // hidden={isAddPermission}
                                        // disabled={isSubmitting}
                                        color="primary"
                                        className="reset"
                                        onClick={handelCancel}
                                    >
                                        <span className="right_5">
                                            <img src={reseticon} alt="" />
                                        </span>{" "}
                                        Reset
                                    </Button>

                                </Col>
                            </Row>
                        </div>
                    </div>);
            }}></Formik>
    )
}
export default SearchContainer;